export default __webpack_public_path__ + "static/media/home-icon.a026539f.webp";